import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const reportName = "Despachos por quantidade de deslocamentos"
const reportId = "displacement-amount"
const DisplacementAmount = ({data}) => {

  useEffect(() => {
    const statusData = GraphicUtils.horizontalStackedBarChart(data, reportId, "displacement");

    if (statusData) {
      const tableRows = statusData.labels.map((label, i) => [label, statusData.values[i]]);
      ReportUtils.createExportableTable(["Descrição", "Quantidade"], tableRows, "Quantidade de deslocamentos");
    }

  }, [data]);

  return (
    <>
      <div className="chart-report relative">
        <span className="chart-title">{reportName}</span>
        <div className="mt-1 flex gap-[3px] w-full" id={reportId}></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};
export default DisplacementAmount;